import AlertsInfoContainer from "./alertsInfoContainer";
export default AlertsInfoContainer;
